module.exports = __webpack_public_path__ + "img/amazon_logo.106975d5.svg";